import React, { useCallback, useEffect, useState, useRef } from "react";

// Lib
import { useWindowSize } from "lib/hooks";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "lib/hooks/useDispatch";

// components
import HeaderList from "./HeaderList";
import UntilTable from "components/UntilTable";

// Classnames
import clsx from "clsx";

// Constants
const GAP_MOBILE: number = 6;
const GAP_DESKTOP: number = 10;
const VIEW_ELEMENTS: number = 4;
const BREAKPOINT_DESKTOP: number = 1024;

export const List: React.FC = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { width: screenWidth } = useWindowSize();

  const { libTargets } = useAppSelector(
    (store) => ({
      libTargets: store.librariesProduct?.libDetailsData?.libTargets || [],
    }),
    shallowEqual
  );

  const [isShow, setIsShow] = useState<boolean>(false);
  const [calcHeight, setCalcHeight] = useState<number>(0);

  useEffect(() => {
    if (wrapperRef.current) {
      const elements = wrapperRef.current.querySelectorAll(".table-until");
      let height = 0;

      elements.forEach((element: Element, i: number) => {
        const elementHeight = element.getBoundingClientRect().height;
        const gap = screenWidth <= BREAKPOINT_DESKTOP ? GAP_DESKTOP : GAP_MOBILE;

        if (!isShow && i <= VIEW_ELEMENTS) {
          height += elementHeight + gap;
        } else if (isShow) {
          height += elementHeight + gap;
        }
      });

      setCalcHeight(height);
    }
  }, [isShow, screenWidth, libTargets]);

  const handlerShowAll = useCallback(() => {
    setIsShow((prev) => !prev);
  }, []);

  const targetCounts = libTargets?.map(
    (x) => x?.targetCount
  ).filter(
    (x): x is number => x !== null && x !== undefined
  ) || [];
  const maxValue = targetCounts.length ? Math.max(...targetCounts) : 0;

  const sortedData = libTargets?.length ?
    [...libTargets].sort(
      (x, y) => (y?.targetCount ?? 0) - (x?.targetCount ?? 0)
    )
    : [];

  const cnWrraperList = clsx(
    "libraries-composition__list",
    !isShow && "libraries-composition__unit--active"
  );

  if (!sortedData?.length) {
    return null;
  }

  return (
    <div className="libraries-composition">
      <div className="libraries-composition__content wrapper">
        <HeaderList />

        <div
          ref={wrapperRef}
          className={cnWrraperList}
          style={{ height: calcHeight ? `${calcHeight.toFixed(0)}px` : "100%" }}
        >
          {sortedData.map(
            (x, i) => (
              <UntilTable
                {...x}
                key={i}
                isChart
                maxValue={maxValue}
              />
            )
          )}
        </div>

        {sortedData.length > 5 && (
          <div
            onClick={handlerShowAll}
            className="libraries-composition__text-show"
          >
            {!isShow ? "Show all" : "Hide all"}
          </div>
        )}
      </div>
    </div>
  );
};

export default List;
